import Splide from '@splidejs/splide';

const sliders = document.querySelectorAll('.home-hair .procedures.splide');

sliders.forEach((slider) => {
    const perPage = parseInt(slider.dataset.perPage, 10) || 3;
    const rightPadding = slider.dataset.rightPadding ?? '10%';

    const splide = new Splide(slider, {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: true,
        pagination: false,
        perPage,
        perMove: 1,
        padding: {
            right: rightPadding
        },
        gap: '16px',
        breakpoints: {
            1460: {
                perPage: Math.min(perPage, 3),
            },
            960: {
                perPage: 1,
                padding: {
                    right: '10%'
                },
            },
        }
    });
    splide.mount();
});
